import AnimateHeight from './AnimateHeight';

class CCAccordion {
	constructor(el) {
		this.$el = el;
		this.$header = el.querySelector('.cc-accordion__header');
		this.$body = el.querySelector('.cc-accordion__body');
		this.$bodyInner = el.querySelector('.cc-accordion__body__inner');
		this.$icon = el.querySelector('.cc-accordion__icon .icon');

		this.init();
	}

	init = () => {
		new AnimateHeight(this.$body);
		this.$header.addEventListener('click', this.toggle);
	};

	toggle = () => {
		if (this.$bodyInner.classList.contains('visible')) {
			this.close();
		} else {
			this.open();
		}
	};

	open = () => {
		this.$el.classList.add('visible');
		this.$bodyInner.classList.add('visible');
		this.$icon.classList.remove('icon-plus');
		this.$icon.classList.add('icon-minus');
	};

	close = () => {
		this.$el.classList.remove('visible');
		this.$bodyInner.classList.remove('visible');
		this.$icon.classList.remove('icon-minus');
		this.$icon.classList.add('icon-plus');
	};
}

const els = Array.from(document.querySelectorAll('.cc-accordion'));
els.forEach(el => {
	new CCAccordion(el);
});
